const SCAFFOLDING_BY_LESSON = {
  'math-shortcuts': {
    prerequisiteNote: 'You should know the standard method before using a shortcut.',
    vocabulary: ['estimate', 'shortcut', 'mental math', 'approximation'],
    greTrap:
      'A shortcut is useful only if it preserves accuracy. If the answer choices are close, calculate exactly.',
  },
  'work-rate': {
    prerequisiteNote: 'Review fractions and the idea that rate means work per unit time.',
    vocabulary: ['rate', 'work', 'time', 'combined rate'],
    greTrap:
      'Do not add completion times. Convert each worker to a rate, then add or subtract rates.',
  },
  'distance-rate': {
    prerequisiteNote: 'Use distance = rate x time, with all units converted first.',
    vocabulary: ['distance', 'rate', 'time', 'average speed'],
    greTrap:
      'Average speed is total distance divided by total time, not always the average of speeds.',
  },
  sets: {
    prerequisiteNote: 'You only need addition, subtraction, and careful category labels.',
    vocabulary: ['union', 'intersection', 'overlap', 'neither'],
    greTrap:
      'When two groups overlap, adding both group counts double-counts the overlap.',
  },
  statistics: {
    prerequisiteNote: 'Review ordering numbers and dividing a total by a count.',
    vocabulary: ['mean', 'median', 'range', 'standard deviation'],
    greTrap:
      'Do not calculate every statistic. First identify which statistic the question asks for.',
  },
  graphs: {
    prerequisiteNote: 'Read labels, axes, units, and table headings before calculating.',
    vocabulary: ['axis', 'trend', 'frequency', 'quartile'],
    greTrap:
      'Many data interpretation errors come from using the wrong unit or row.',
  },
  triangles: {
    prerequisiteNote: 'Review angle sums, area, and the Pythagorean theorem.',
    vocabulary: ['hypotenuse', 'similar', 'altitude', 'ratio'],
    greTrap:
      'Do not assume a triangle is right or isosceles unless the diagram or text says so.',
  },
  circles: {
    prerequisiteNote: 'Know the difference between radius, diameter, circumference, and area.',
    vocabulary: ['radius', 'diameter', 'arc', 'sector'],
    greTrap:
      'Diameter is twice the radius. Check which one the problem gives before using a formula.',
  },
  'coordinate-geometry': {
    prerequisiteNote: 'Review plotting points and subtracting coordinates.',
    vocabulary: ['slope', 'intercept', 'midpoint', 'distance'],
    greTrap:
      'Keep point order consistent when computing slope; sign errors are common.',
  },
  functions: {
    prerequisiteNote: 'A function takes an input and returns an output.',
    vocabulary: ['input', 'output', 'domain', 'composition'],
    greTrap:
      'For composition, evaluate the inside function first.',
  },
};

export const RUNTIME_SCAFFOLDED_LESSONS = Object.keys(SCAFFOLDING_BY_LESSON);

export const applyLessonScaffolding = (lessonId, sections = []) => {
  const scaffold = SCAFFOLDING_BY_LESSON[lessonId];
  if (!scaffold) return sections;

  return sections.map((section) => ({
    ...section,
    content: {
      ...section.content,
      concepts: (section.content?.concepts || []).map((concept) => ({
        ...concept,
        prerequisiteNote: concept.prerequisiteNote || scaffold.prerequisiteNote,
        vocabulary: concept.vocabulary || scaffold.vocabulary,
        greTrap: concept.greTrap || scaffold.greTrap,
      })),
    },
  }));
};
